export default "__VITE_ASSET__C$bwQH$H__"